import React from 'react';
import styled from 'styled-components';
import { FooterLinks } from '../FooterLinks';

const Wrapper = styled.div`
  position: relative;
  background-color: #1c0a1c;
  padding-top: 70px;
  color: white;
`;
const CompanyTitle = styled.div`
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  // padding-bottom: 30px;
  font-weight: 500;
  line-height: 1.2;
  font-family: AvenirBold;
  @media (max-width: 992px) {
    padding-bottom: 8px;
  }
  @media (max-width: 768px) {
    padding-bottom: 30px;
  }
`;
const RightsCol = styled.div`
  border-top: 1px solid grey;
  width: 100%;
  bottom: 0px;
  padding: 28px 0px;
  font-family: Avenir-Black;
  font-size: 18px;
`;
const RightsRow = styled.div`
  height: 160px;
`;
const CompanyAddress = styled.div`
  font-size: 16px;
  color: #a7a0a7;
  width: 60%;
  padding-top: 30px;
`;
const CompanyContact = styled.div`
  font-size: 16px;
  color: #a7a0a7;
  width: 60%;
  padding-top: 10px;
`;

const servicesLinks = [
  { pageTitle: 'Quality Assurance (QA)', pageLink: '/services', id: '4' },
  { pageTitle: '2D & 3D Art', pageLink: '/services', id: '2' },
  { pageTitle: 'Creative Marketing', pageLink: '/services', id: '5' },
  { pageTitle: 'Content & Game Design', pageLink: '/services', id: '1' },
  { pageTitle: 'Game Engineering', pageLink: '/services', id: '3' }
];
const mainLinks = [
  { pageTitle: 'About', pageLink: '/about' },
  { pageTitle: 'Work', pageLink: '/work' },
  { pageTitle: 'Careers', pageLink: '/contact' },
  { pageTitle: 'Contact', pageLink: '/contact' },
  { pageTitle: 'Privacy', pageLink: '/privacy' }
];

const Footer = props => (
  <footer>
    <Wrapper>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-6 col-md-4'>
            <CompanyTitle>we.R.play</CompanyTitle>
            <div className='d-none d-md-block'>
              <CompanyAddress>
                Plot# 395/396 Service Rd N, I-9/3, Islamabad, Pakistan.
              </CompanyAddress>
              <CompanyContact>(051) 4859017</CompanyContact>
              <CompanyContact>connect@werplay.com</CompanyContact>
            </div>
          </div>
          <div className='col-lg-3 col-md-4 mb-4 mb-md-0'>
            <FooterLinks
              updateSelectOption={props.updateSelectOption}
              title='Services'
              links={servicesLinks}
            />
          </div>
          <div className='col-lg-3 col-md-4 mt-4 mt-md-0'>
            <FooterLinks title='Space Station' links={mainLinks} />
          </div>
          <div className='col-sm-12 d-block d-xl-none d-lg-none d-md-none'>
            <CompanyAddress>
              Plot# 395/396 Service Rd N, I-9/3, Islamabad, Pakistan.
            </CompanyAddress>
            <CompanyContact>(051) 4859017</CompanyContact>
            <CompanyContact>connect@werplay.com</CompanyContact>
          </div>
        </div>
        <RightsRow className='row'>
          <div className='col mt-auto'>
            <RightsCol>All Rights Reserved ©</RightsCol>
          </div>
        </RightsRow>
      </div>
    </Wrapper>
  </footer>
);

export { Footer };
